export enum InvestingType {
  Individual = "Individual",
  Company = "Company",
}

export enum QuestionType {
  MultiChoice = "MultiChoice",
  CurrencyValue = "CurrencyValue",
  IntegerValue = "IntegerValue",
  FloatValue = "FloatValue",
  Text = "Text",
  MultiValue = "MultiValue",
  Percentage = "Percentage",
  Information = 'Information',
  UploadFile = 'UploadFile',

}


export interface Answer {
  id: string;
  textAr: string;
  textEn: string;
  hasNote: boolean;
  childQuestions: Question[];
  relatedQuestionId?: string;
  isFileUpload?: boolean;
  isSelected?: boolean;//only for ui purpose
}
export interface GetRegisterationQuestionsOutputDto {
  categoryId: string,
  categoryNameAr: string,
  categoryNameEn: string,
  questions: Question[],
}
export interface Question {
  id: string;
  titleAr: string;
  titleEn: string;
  questionTypeId: string;
  imageUrl: string | null;
  isMultipleAnswer: boolean;
  isMandatory: boolean;
  answers: Answer[] | null;
  isCountryQuestion: boolean;
  childQuestions?: Question[]; // Add this to support nested questions
  /** New, additive field from the backend: which widget this question is answered through (matches QuestionType above). */
  answerInputType?: QuestionType;
}
export interface Category {
  categoryId: string;
  categoryNameAR: string;
  categoryNameEN: string;
  questions: Question[];
}

export interface QuestionsResponse {
  questionId?: string;
  questionTypeId?: string;
  textAnswer?: string | undefined;
  numericAnswer?: number | 0;
  answerId?: string | undefined;
  answers?: QuestionsResponse[]

}
export interface SubmitKYCAnswersInputDto {
  singleAnswerList: QuestionsResponse[],
  multiAnswersList: QuestionsResponse[],
  investorSignature?: string,

}
export interface UploadKycInputDto {
  "fileBase64": string,
  "fileExtention": string,
}
export interface KYCAnswerDetailsResponse{
  categorizedAnswers:DashUserAnswersDto[],
 investorSignature?:string,
 requestId?:string,
}
export interface DashUserAnswersDto{
  categoryId:string,
categoryNameAr:string
categoryNameEn:string,
answers:KYCUserAnswersDto[]

}
export interface KYCUserAnswersDto {
  questionId: string; // Guid type in C# maps to string in TypeScript
  questionTypeId: QuestionType; // Enum type should be kept as is
  questionTitleAr: string;
  questionTitleEn: string;
  answersList: AnswersListDto[]; // List<T> in C# maps to an array in TypeScript
}
export interface AnswersListDto {
  userAnswerId: string; // Guid type in C# maps to string in TypeScript
  answerTextAr: string|null;
  answerTextEn: string|null;
  statusId: UserAnswerStatus; // Enum type should be kept as is
  numericAnswer?: number|null; // Nullable decimal in C# becomes optional number in TypeScript
  textAnswer: string|null;
  isFileUpload?:boolean|null;
}
export enum UserAnswerStatus {
  Pending = 0,
  Approved = 1,
  Rejected = 2,
  ReSubmit=3,
}

// ---- Real backend contract for AddUserKycAnswers (api/1/KYC/AddUserKycAnswers). ----
// NOTE: SubmitKYCAnswersInputDto above (singleAnswerList/multiAnswersList/investorSignature) does NOT
// match the live backend DTO and has no consumers today — use UserKycAnswersRequest below instead.

export enum EducationalQualification {
  Postgraduate = 1,
  Graduate = 2,
  Diploma = 3,
  HighSchool = 4,
  IntermediateSchool = 5,
  Other = 6,
}

export enum EmploymentStatus {
  Retired = 1,
  BusinessOwner = 2,
  Employed = 3,
  Unemployed = 4,
  Student = 5,
  Other = 6,
}

export enum MartialStatus {
  Single = 1,
  Married = 2,
}

export interface WorkplaceInformationRequest {
  companyName?: string;
  companyAddress?: string;
  companyTelephone?: string;
  jobTitle?: string;
  workExperience?: string;
}

export interface KycCompanyAuthorizedPersonRequest {
  firstName: string;
  lastName: string;
  designation?: string;
  mobile: string;
  telephone?: string;
  fax?: string;
  email: string;
  birthdate?: string;
  nid: string;
  isPhoneNumberVerified?: boolean;
}

export interface KycNationalAddressRequest {
  buildingNumber?: string;
  street?: string;
  additionalNumber?: string;
  district?: string;
  city?: string;
  postalCode?: string;
  unitNumber?: string | number;
}

export interface KycFileAnswerRequest {
  questionId: string;
  storedFileId: string;
}

export interface KycValueAnswerRequest {
  questionId: string;
  value: string;
}

export type InvestorKycStatus = 'NotSubmitted' | 'Pending' | 'Proccessing' | 'Approved' | 'Rejected' | 'Cancelled';

export interface InvestorKycChoiceAnswer {
  questionId: string;
  choiceId: string;
}

export interface InvestorKycFileAnswer {
  questionId: string;
  storedFileId: string;
  fileName?: string;
}

export interface InvestorKycDetails {
  status: InvestorKycStatus;
  educationalQualification?: number | null;
  employmentStatus?: number | null;
  martialStatus?: number | null;
  incomeSource?: string | null;
  workplaceInformation?: WorkplaceInformationRequest | null;
  choiceAnswers?: InvestorKycChoiceAnswer[];
  valueAnswers?: KycValueAnswerRequest[];
  fileAnswers?: InvestorKycFileAnswer[];
}

export interface UserKycAnswersRequest {
  /** Individual: ids of selected Choice rows for MultiChoice questions. */
  choicesId?: string[];
  educationalQualification?: EducationalQualification;
  employmentStatus?: EmploymentStatus;
  martialStatus?: MartialStatus;
  incomeSource?: string;
  workplaceInformation?: WorkplaceInformationRequest;
  /** Company only. */
  authorizedPerson?: KycCompanyAuthorizedPersonRequest;
  address?: KycNationalAddressRequest;
  /** Answers to AnswerInputType.UploadFile questions. */
  fileAnswers?: KycFileAnswerRequest[];
  /** Answers to scalar-value questions (Text/IntegerValue/FloatValue/CurrencyValue/Percentage). */
  valueAnswers?: KycValueAnswerRequest[];
}